import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    errorLabel: {
        fontWeight: "bold",
        color: "red",
        minWidth: 155
    },
    selectLabel: {
        fontWeight: "bold",
        color: "#002F36",
        minWidth: 155,
        "&.Mui-focused": {
            color: "#002F36"
        }
    },
    selectBox: {
        minWidth: 270,
        border: "1.5px solid #333333",
        color: "#495057",
        height: "calc(1.5em + .75rem + 2px)",
        borderRadius: 4,
        "& .MuiInput-underline:before": {
            borderColor: "#333333"
        },
        "& .MuiInputBase-input": {
            textAlign: "center",
            padding: "8px 7px 7px",
        },
        "& .MuiSelect-select:focus": {
            backgroundColor: "white"
        }
    }
});